import { useTheme } from "../context/ThemeContext";
import { useTranslation } from "react-i18next";
import "../css/ThemeToggle.css";

type Props = {
  variant?: "inline" | "floating";
};

export default function ThemeToggle({ variant = "inline" }: Props) {
  const { t } = useTranslation();
  const { theme, toggleTheme } = useTheme();
  const nextTheme = theme === "dark" ? "light" : "dark";
  const nextThemeLabel = nextTheme === "light" ? t("theme.switchToLight") : t("theme.switchToDark");

  return (
    <button
      type="button"
      className={`themeToggle themeToggle--${variant}`}
      onClick={toggleTheme}
      aria-label={nextThemeLabel}
      title={nextThemeLabel}
    >
      <span className={`themeToggle-track themeToggle-track--${theme}`} aria-hidden="true">
        <span className="themeToggle-thumb" />
      </span>
      <span className="themeToggle-text">{theme === "dark" ? t("theme.night") : t("theme.day")}</span>
    </button>
  );
}
